import axiosClient from "./axiosClient";
import ROUTES from "./api_routes";

async function partners() {
  return axiosClient.get(ROUTES.GET_PARTNERS);
}
    
const PartnersClient = {
  partners
};

export default PartnersClient;

